export default "__VITE_ASSET__7tU6x5r3__"